import "./LoadingStyle.css";
var LoadingComponent = /** @class */ (function () {
    function LoadingComponent(sizeInRem) {
        this.sizeInRem = sizeInRem;
        if (sizeInRem == null) {
            this.sizeInRem = 6;
        }
    }
    LoadingComponent.prototype.isEqual = function (node) {
        return this.__proto__ === node.__proto__;
    };
    LoadingComponent.prototype.render = function () {
        return {
            tag: "div",
            attr: { style: "font-size:" + this.sizeInRem + "rem" },
            content: "<div class='lds-dual-ring'></div>",
            raw: true
        };
    };
    return LoadingComponent;
}());
export { LoadingComponent };
